const Backbone = require('backbone');
const UserRepository = require('common/domain/repository/user');

module.exports = Backbone.Model.extend({
    defaults: {
        user: null,
        role: 'owner',
        suspended: false
    },

    initialize: function() {
        this._user = UserRepository.create(this.get('user'));
    },

    getRole: function() {
        return this.get('role');
    },

    isOwner: function() {
        return (this.get('role') === 'owner');
    },

    isPlayer: function() {
        return (this.get('role') === 'player');
    },

    isCollaborator: function() {
        return (this.get('role') === 'collaborator');
    },

    getUser: function() {
        return this._user;
    },

    isSuspended: function() {
        return this.get('suspended');
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/project-member.js